import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import OtpInput from "react-otp-input";
import AuthGeneralInput from "../../components/input/authinput";
import { AppButton } from "../../components/buttons/button";
import { H1Title, Paragraph } from "../../components/typography/typography";
import AuthService from "../../services/authService";
import { Success, Error as ToastError } from "../../components/toast/toast";
import _route from "../../constants/routes";

export default function ResetPassword() {
  const emailFromStore = useSelector((state) => state.auth.email);
  const [email, setEmail] = useState(emailFromStore || '');
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      ToastError('Passwords do not match');
      return;
    }
    if (password.length < 8) {
      ToastError('Password must be at least 8 characters');
      return;
    }
    if (otp.length !== 6) {
      ToastError('Please enter the 6-digit code');
      return;
    }

    setLoading(true);
    try {
      await AuthService.resetPassword({ email, otp, password });
      Success('Password reset! Please log in.');
      navigate(_route._login);
    } catch (err) {
      ToastError(err.response?.data?.error?.message || 'Failed to reset password');
    } finally { setLoading(false); }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full space-y-5">
      <div>
        <H1Title size="sm">Reset Your Password</H1Title>
        <Paragraph size="base" className="text-grey-667 mt-1">
          Enter the 6-digit code we sent to your email and your new password.
        </Paragraph>
      </div>

      <AuthGeneralInput
        label="Email"
        type="email"
        name="email"
        placeholder="Enter your email"
        value={email}
        change={(e) => setEmail(e.target.value)}
      />

      <div>
        <label className="block text-xs md:text-sm mb-2 text-black">Reset Code <span className="text-red-500">*</span></label>
        <div className="flex justify-center">
          <OtpInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            renderInput={(props) => (
              <input {...props}
                className="!w-12 !h-12 mx-1 text-center text-lg font-semibold border border-grey-200 rounded-md outline-none focus:border-primary"
              />
            )}
            shouldAutoFocus
          />
        </div>
      </div>

      <AuthGeneralInput
        label="New Password"
        type="password"
        name="password"
        placeholder="Min 8 characters"
        value={password}
        change={(e) => setPassword(e.target.value)}
      />

      <AuthGeneralInput
        label="Confirm New Password"
        type="password"
        name="confirmPassword"
        placeholder="Re-enter password"
        value={confirmPassword}
        change={(e) => setConfirmPassword(e.target.value)}
      />

      <AppButton type="submit" loading={loading}>
        Reset Password
      </AppButton>

      <p className="text-sm text-center text-grey-667">
        <Link to={_route._login} className="text-primary font-semibold hover:underline">
          Back to Sign In
        </Link>
      </p>
    </form>
  );
}
